<div class="main-container">
    <div class="login-container">
        <div class="content-block">
            <div class="status-pill">Login Error!</div>
            <div class="message">{{ errorMessage }}</div>
            <button *ngIf="loginFeatureEnabled" class="action-btn" (click)="redirectToLogin()">{{ btnText }}</button>
        </div>
    </div>
</div>
